enum REQUEST_STATUS {
  IDLE = 'IDLE',
  INIT = 'INIT',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export default REQUEST_STATUS;
